export const SESSION_CONFIG = {
  // Backend token lifetimes
  ACCESS_TOKEN_LIFETIME: 20 * 60 * 1000,
  REFRESH_TOKEN_LIFETIME: 24 * 60 * 60 * 1000,

  // Frontend inactivity detection
  INACTIVITY_TIMEOUT: 19 * 60 * 1000,
  MODAL_AUTO_LOGOUT: 60 * 1000,

  // Auto-refresh strategy
  AUTO_REFRESH_ENABLED: true,
  AUTO_REFRESH_INTERVAL: 18 * 60 * 1000,
  REFRESH_ON_ACTIVITY_THRESHOLD: 5 * 60 * 1000,

  // Safety buffers
  SAFETY_BUFFER: 2 * 60 * 1000,
  REFRESH_LOCK_TIMEOUT: 10 * 1000,
  SLEEP_DETECTION_THRESHOLD: 2 * 60 * 1000,

  // Token age thresholds
  MIN_TOKEN_AGE_FOR_REFRESH: 15 * 60 * 1000,
  INITIAL_REFRESH_DELAY: 1 * 60 * 1000,

  // Storage keys
  STORAGE_KEYS: {
    LAST_ACTIVITY: 'w360-last-activity',
    MODAL_OPENED_AT: 'w360-modal-opened-at',
    MODAL_EXPIRES_AT: 'w360-modal-expires-at',
    REFRESH_LOCK: 'w360-refresh-lock',
    LEADER_TAB: 'w360-modal-leader',
    TOKEN_EXPIRES_AT: 'w360-token-expires-at',
    TOKEN_ISSUED_AT: 'w360-token-issued-at',
  },
} as const

export type SessionConfig = typeof SESSION_CONFIG
